import { getCurrentUserSession } from 'providers/auth'
import { addEndpoint, addQueryParams } from 'utils/api'
export { search } from './search'
export { searchNetsuite } from './search-netsuite'
export { list } from './list'
export { create } from './create'
export { read } from './read'
export { update } from './update'
export { reactivate } from './reactivate-user'
export { reinstate } from './reinstate-user'
export { clearDevices } from './clear-devices'
export { indexRecord } from './index-record'
export { sendInstructions } from './send-instructions'
export { dcAccess } from './dc-access'
export { deactivate } from './deactivate-user'

const getApiUrl = () => process.env.REACT_APP_API as string
export const API_URL = getApiUrl()
export type ErrorProp = string

export const authorizedAction = async ({
  action,
  body,
}: {
  action:
    | 'Devices.Clear'
    | 'Student.Unlock'
    | 'Student.Lock'
    | 'Student.Deactivate'
    | 'Student.Reactivate'
    | 'Student.Reinstate'
    | 'Student.SendInstructions'
    | 'Student.UpdateProgress'
    | 'Teacher.EnrollToLMSCourse'
    | 'Teacher.EnrollToRefresherCourse'
    | 'Teacher.LMSReactivate'
    | 'Teacher.LMSDeactivate'
    | 'Teacher.LMSResendLegal'
    | 'Search.IndexRecord'
    | 'Teacher.LMSDeactivateRefresher'
    | 'Teacher.LMSReactivateRefresher'
  body?: object
}) => {
  const endpoint = `user/actions`
  return await authorizedRequest({
    endpoint,
    method: 'POST',
    body,
    headers: { Action: action },
  })
}

export const authorizedGet = async ({
  endpoint,
  params,
}: {
  endpoint: string
  params?: { [key: string]: string | undefined }
}) => {
  return await authorizedRequest({
    endpoint,
    method: 'GET',
    params,
  })
}

export const authorizedRequest = async ({
  endpoint,
  method,
  body,
  params,
  headers,
}: {
  endpoint: string
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
  body?: object
  params?: { [key: string]: string | undefined }
  headers?: {
    [header: string]: string
  }
}) => {
  try {
    const url = new URL(getApiUrl())
    addEndpoint(url, endpoint)
    params && addQueryParams(url, params)

    const { session } = await getCurrentUserSession()
    if (!session) {
      throw Error('Current user session not found')
    }
    const idToken = session.getIdToken().getJwtToken()
    const response = await fetch(url.toString(), {
      method: method,
      headers: {
        Authorization: `${idToken}`,
        'Content-Type': 'application/json',
        ...headers,
      },
      body: JSON.stringify(body),
    })
    if (response.ok) {
      return response
    } else {
      const responseJSON = await response.json()
      const error = Error(responseJSON.error ?? responseJSON.message)
      ;(error as any).responseData = responseJSON
      throw error
    }
  } catch (e: any) {
    if (e.message === 'Failed to fetch') {
      throw Error(
        'Please check your Internet connection and load the page again'
      )
    }
    throw e
  }
}
